import React, { useEffect, useState } from 'react';
import './Sidebar.css';
import { clearJwtCookie, getIsAdmin } from './auth/auth';
import Swal from 'sweetalert2';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import WarningModal from './WarningModal';
import * as CustomStyle from '../components/CustomStyle'
import SensorsIcon from '@mui/icons-material/Sensors';

const Sidebar = ({ isMenuOpen, setIsMenuOpen}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [openWarning, setOpenWarning] = useState(false);
    const isAdmin = getIsAdmin();

    //handle sidebar toggle on mobile view
    useEffect(() => {
        const sidebar_expanded = document.querySelector('.expanded');
        if (sidebar_expanded){
            if(!isMenuOpen ){
                sidebar_expanded.classList.remove('expanded');
                setIsMenuOpen(false);
            }
        }
    }, [location.pathname]);

    const handleSignOut = async (event) => {
        setOpenWarning(false);
        clearJwtCookie();

        Swal.fire({
            icon: 'success',
            title: 'Logged out',
            text: 'You have successfully logged out.',
            confirmButtonText: 'OK',
            confirmButtonColor: '#0088FF'
        }).then(() => {
            navigate('/login');
        });
    };


    return (
      <div className={`sidebar ${isMenuOpen  ? 'expanded' : ''}`}>
          <div className="sensor-container">
            <div className={`stations-position ${isMenuOpen  ? 'expanded' : ''}`}>
              <Link
                to="station_list_page"
                className={location.pathname === "/station_list_page" ? "sidebar-button active" : "sidebar-button"}
                title={!isMenuOpen  ? 'List Stations' : ''}
              >
                <button className="sidebar-nav-button">
                  <span className="material-symbols-outlined sidebar-li-icon">sensors</span>
                  {isMenuOpen  && <div className="button-label">Stations</div>}
                </button>
              </Link>
            </div>
          </div>


        <div className={`logout-position ${isMenuOpen  ? 'expanded' : ''}`}>
          <button
            className="sidebar-logout-button"
            onClick={() => setOpenWarning(true)}
            title={!isMenuOpen  ? 'Log out' : ''}
          >
            <span className="material-symbols-outlined sidebar-li-icon">logout</span>
            {isMenuOpen  && <div className="button-label">Logout</div>}
          </button>
        </div>

        <WarningModal
          open={openWarning}
          onClick={handleSignOut}
          onClose={() => setOpenWarning(false)}
          sx={{ ...CustomStyle.modalMedium }}
          text={"Are you sure you want to log out?"}
        />
      </div>
    );

};

export default Sidebar;
